import React from 'react';
import { ArrowLeft, User, Hash } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

/**
 * Sticky Header - Reste visible au scroll
 */
const StickyHeader = ({ 
  operation, 
  onBack, 
  getStatusBadge,
  formatPrice 
}) => {
  return (
    <div className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-2">
          {/* Left: Back + Operation Info */}
          <div className="flex items-center gap-2 sm:gap-3 flex-wrap min-w-0">
            <Button 
              variant="ghost" 
              size="sm"
              onClick={onBack}
              className="hover:bg-gray-100"
            >
              <ArrowLeft className="w-4 h-4 mr-1" />
              Retour
            </Button>
            
            <div className="h-6 w-px bg-gray-300 hidden sm:block" />
            
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap min-w-0">
              <h1 className="text-base sm:text-lg font-bold text-gray-900 truncate max-w-full">
                {operation.operationNumber || `OP-${operation.id.substring(0, 8)}`}
              </h1>
              {getStatusBadge(operation.status)}

              {operation.externalRef && (
                <Badge
                  variant="outline"
                  className="text-xs font-mono border-emerald-300 bg-emerald-50 text-emerald-800"
                  title={operation.externalRefLabel || 'Référence client'}
                  data-testid="header-external-ref"
                >
                  <Hash className="w-3 h-3 mr-1" />
                  {operation.externalRef}
                </Badge>
              )}
              
              {operation.intraInterLand && (
                <Badge variant="outline" className="text-xs">
                  {operation.intraInterLand}
                </Badge>
              )}
              
              {operation.assignedOperatorName && (
                <Badge variant="outline" className="text-xs hidden md:flex">
                  <User className="w-3 h-3 mr-1" />
                  {operation.assignedOperatorName}
                </Badge>
              )}
            </div>
          </div>

          {/* Right: Price */}
          <div className="text-right hidden sm:block">
            <p className="text-xs text-gray-500">Prix estimé</p>
            <p className="text-lg font-bold text-emerald-600">
              {formatPrice(operation.finalPrice || operation.estimatedPrice)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyHeader;
